import { render, staticRenderFns } from "./OrgChartForm.vue?vue&type=template&id=4adda4a9"
import script from "./OrgChartForm.vue?vue&type=script&lang=js"
export * from "./OrgChartForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4adda4a9')) {
      api.createRecord('4adda4a9', component.options)
    } else {
      api.reload('4adda4a9', component.options)
    }
    module.hot.accept("./OrgChartForm.vue?vue&type=template&id=4adda4a9", function () {
      api.rerender('4adda4a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrgChart/OrgChartForm.vue"
export default component.exports